import { QueryHookOptions } from '@apollo/client'
import {
  IEscalatedIssuesQuery,
  IEscalatedIssuesQueryVariables,
  useEscalatedIssuesQuery,
} from '../graphql/EscalatedIssues'
import { useSetNotifiedEscalatedShipmentIssuesMutation } from '../graphql/SetNotifiedEscalatedShipmentIssuesMutation'
import { getFirstTimeNotifiedIssues } from '../utils/getFirstTimeNotifiedIssues'

const NUMBER_OF_ISSUES = 3

export const useEscalatedIssues = (
  props: QueryHookOptions<IEscalatedIssuesQuery, IEscalatedIssuesQueryVariables> = {}
) => {
  const [setNotifiedEscalatedFields] = useSetNotifiedEscalatedShipmentIssuesMutation()

  const markAsNotifiedEscalated = (data: IEscalatedIssuesQuery) => {
    const { paginatedShipmentIssues } = data || {}
    const { nodes: issues = [] } = paginatedShipmentIssues || {}
    const firstTimeNotifiedIssues = getFirstTimeNotifiedIssues(issues)
    if (firstTimeNotifiedIssues?.length)
      setNotifiedEscalatedFields({
        variables: {
          input: {
            shipmentIssues: firstTimeNotifiedIssues,
          },
        },
      })
  }

  const { data, error, loading, ...rest } = useEscalatedIssuesQuery({
    variables: {
      first: NUMBER_OF_ISSUES,
      userEscalated: true,
    },
    // We need to be able to track whether we DID notify/escalate issues to users so this sends back list
    // of issues that were just notified/escalated once query has completed.
    onCompleted: markAsNotifiedEscalated,
    ...props,
  })

  const { paginatedShipmentIssues } = data || {}
  const { nodes: issues = [], totalCount = 0 } = paginatedShipmentIssues || {}

  return {
    ...rest,
    data: issues,
    issueCount: totalCount,
    error: error?.message || '',
    loading,
  }
}
